import { ref } from '@vue/composition-api'
import { ValidationRules, ValidationState } from '@/modules/kisweui/types/validation'
import useVuelidate from '@vuelidate/core'

const useValidationCheck = (rules: ValidationRules, state: ValidationState) => {
  const validator = useVuelidate(rules, state)
  const showError = ref(false)
  const isValidForm = () => {
    if (validator.value.$invalid) {
      validator.value.$touch()
      showError.value = true
      return false
    }
    showError.value = false
    return true
  }
  return {
    isValidForm,
    showError,
    validator
  }
}

export default useValidationCheck
